exports.initialize = ->
  jQuery('[data-toggle="tooltip"]').tooltip({html: true})



// WEBPACK FOOTER //
// ./src/libraries/tooltip.coffee